/**
 * CostSchemeDrawer — the right-side detail drawer for the selected board part. Thin wrapper around
 * {@link OverlayDrawer} that mounts a fresh {@link PartDetailForm} per selected part (keyed by uid, so
 * switching parts resets the form's local state cleanly). Renders nothing when no part is selected.
 */
import { useTranslation } from 'react-i18next';

import type { BoardPart } from '../model';
import { OverlayDrawer } from './OverlayDrawer';
import { PartDetailForm } from './PartDetailForm';

interface CostSchemeDrawerProps {
  part: BoardPart | null;
  readOnly: boolean;
  onClose: () => void;
  onUpdatePart: (uid: string, patch: Partial<BoardPart>) => void;
  onDeletePart: (uid: string) => void;
}

export function CostSchemeDrawer({
  part,
  readOnly,
  onClose,
  onUpdatePart,
  onDeletePart,
}: CostSchemeDrawerProps) {
  const { t } = useTranslation('venua-planner');
  return (
    <OverlayDrawer
      open={part != null}
      onClose={onClose}
      width="760px"
      ariaLabel={t('costScheme.drawer.title')}
    >
      {part ? (
        <PartDetailForm
          key={part.uid}
          part={part}
          readOnly={readOnly}
          onClose={onClose}
          onUpdatePart={onUpdatePart}
          onDeletePart={onDeletePart}
        />
      ) : null}
    </OverlayDrawer>
  );
}
